import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import {
  GetNewIzlaznaFakturaForUplataQuery,
  IzlaznaFakturaDto,
  IzlazneFaktureClient,
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IzlaznaFakturaZaStrankuResolver
  extends BaseService
  implements Resolve<IzlaznaFakturaDto> {
  constructor(private _client: IzlazneFaktureClient, private _router: Router) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<IzlaznaFakturaDto>
    | Promise<IzlaznaFakturaDto>
    | IzlaznaFakturaDto
    | null {
    return this._client.getNewForStranka(route.paramMap.get('strankaId')).pipe(
      map((res) => res.data),
      catchError(this.handleError),
      finalize(() => {
        //this._configService.setIsBusy = false;
      })
    );
  }
}
